/**
 * @file ppde页关于我们
 * @author FengGuang(fengguang01@baidu.com)
 */
import React, {useCallback, useMemo} from 'react';
import VideoItem from './components/video-item/VideoItem';
import {Col, Row} from 'antd';
import {IAboutUsProps} from './types';
import A from '../../../../components/a/A';


import StepIcon1 from './image/step1.png';
import StepIcon2 from './image/step2.png';
import StepIcon3 from './image/step3.png';
import StepIcon4 from './image/step4.png';

const AboutUs: React.FC<IAboutUsProps> = (props) => {
    const video = props.video || {};
    const list = props.list || [];

    const onJoinClick = useCallback(() => {
        if ((window as any)._hmt) {
            (window as any)._hmt.push([
                '_trackEvent',
                'ppde',
                '申请加入',
                '关于我们点击申请加入'
            ]);
        }
    }, []);

    const stepList = useMemo(() => {
        return [{
            icon: StepIcon1,
            title: '提交申请'
        }, {
            icon: StepIcon2,
            title: '提供材料'
        }, {
            icon: StepIcon3,
            title: '评委审核'
        }, {
            icon: StepIcon4,
            title: '公布结果'
        }];
    }, []);

    return (
        <div className="paddle-ppde-about-us">
            <A href="https://paddle.wjx.cn/jq/81813009.aspx" target onClick={onJoinClick}>
                <Row className="paddle-ppde-about-us-step">
                    {stepList.map((item, index) => (
                        <Col key={index} xs={6}>
                            <div className="paddle-ppde-about-us-step-item">
                                <div
                                    className="paddle-ppde-about-us-step-item-icon"
                                    style={{backgroundImage: `url(${item.icon})`}}
                                />
                                <div className="paddle-ppde-about-us-step-item-title">{item.title}</div>
                                <div className="paddle-ppde-about-us-step-item-line" />
                            </div>
                        </Col>
                    ))}
                </Row>
            </A>
            <div className="paddle-ppde-about-us-body clear-both">
                <VideoItem {...video} />
                <div className="paddle-ppde-about-us-left">
                    <div className="paddle-ppde-about-us-title">
                        <i className="paddle-ppde-about-us-title-icon paddle-ppde-about-us-title-icon1" />
                        PPDE申请条件
                        <span className="paddle-ppde-about-us-title-extra">
                        （备注：以下三者满足其一即可）
                    </span>
                    </div>
                    <div className="paddle-ppde-about-us-text">
                        <p>应用飞桨产出优质开源项目4＋次；或技术文章2＋篇；或GitHub提PR ４＋次</p>
                        <p>乐于为飞桨开源社区的发展贡献力量，作为技术分享主讲人2＋次</p>
                        <p>将飞桨应用于实际业务、比赛、科研论文、书籍撰写、课程开设等</p>
                    </div>
                </div>
            </div>
            <div className="paddle-ppde-about-us-body">
                <div className="paddle-ppde-about-us-title">
                    <i className="paddle-ppde-about-us-title-icon paddle-ppde-about-us-title-icon2" />
                    飞桨开源社区也提供了全流程成长体系和资源
                </div>
                <div className="paddle-ppde-about-us-img-list">
                    <Row gutter={20}>
                        {list.map((it, index) => {
                            const item = it || {};
                            return (
                                <Col key={index} xs={6}>
                                    <A
                                        href={item.link}
                                        target
                                    >
                                        <div
                                            className="paddle-ppde-about-us-img-item"
                                            style={{backgroundImage: item.img ? `url(${item.img})` : undefined}}
                                        >
                                            <div
                                                className="paddle-ppde-about-us-img-item-title"
                                            >
                                                {item.title}
                                            </div>
                                        </div>
                                    </A>
                                </Col>
                            );
                        })}
                    </Row>
                </div>
            </div>
        </div>
    );
};

export default AboutUs;
